import { render, staticRenderFns } from "./Snapshots.vue?vue&type=template&id=fdd50ce0&"
import script from "./Snapshots.vue?vue&type=script&lang=js&"
export * from "./Snapshots.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports